"use client";

import { type RefObject, useEffect, useLayoutEffect, useRef } from "react";

const NEAR_BOTTOM_PX = 120;

/** Keeps a thread pinned to the bottom while new messages arrive, unless the reader scrolled up. */
export function useMessengerStickToBottom(
  contentKey: string,
): RefObject<HTMLDivElement | null> {
  const ref = useRef<HTMLDivElement | null>(null);
  const pinned = useRef<boolean>(true);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = (): void => {
      pinned.current = el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !pinned.current) return;
    el.scrollTop = el.scrollHeight;
  }, [contentKey]);

  return ref;
}
